import React from 'react';
import { Flex } from 'rebass';
import Frame from 'components/Frame';

import AdminNavigation from 'modules/Admin/components/AdminNavigation';
import useAdmin from 'modules/Admin/hooks/useAdmin';
import UsersList from 'modules/Admin/components/UsersList';

const Admin: React.FC<any> = (): JSX.Element => {
  const {
    recruiterRoleTypeHandler,
    employerRoleTypeHandler,
    userLinkHandler,
    userRoleType,
    usersList,
  } = useAdmin();
  return (
    <Frame>
      <Flex width="100%" alignItems="center" flexDirection="column">
        <AdminNavigation
          userRoleType={userRoleType}
          recruiterRoleTypeHandler={recruiterRoleTypeHandler}
          employerRoleTypeHandler={employerRoleTypeHandler}
        />
        <UsersList list={usersList} userRoleType={userRoleType} userLinkHandler={userLinkHandler} />
      </Flex>
    </Frame>
  );
};

export default Admin;
